import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ApplicantsIcon({ className }: IconProps) {
  return (
    <svg
      width="97"
      height="82"
      viewBox="0 0 97 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1476)">
        <path
          d="M59.1083 64.0405H27.5879V76.542H59.1083V64.0405Z"
          fill="#EAEEF9"
        />
        <path
          d="M81.9478 66.3797H4.72019C2.12409 66.3797 0 64.2745 0 61.7014V4.67829C0 2.10523 2.12409 0 4.72019 0H81.9478C84.5439 0 86.668 2.10523 86.668 4.67829V61.7014C86.668 64.2745 84.5439 66.3797 81.9478 66.3797Z"
          fill="#EAEEF9"
        />
        <path
          d="M72.1135 82H14.5796C13.0587 82 11.8262 80.7784 11.8262 79.271C11.8262 77.7635 13.0587 76.542 14.5796 76.542H72.1135C73.6345 76.542 74.867 77.7635 74.867 79.271C74.867 80.7784 73.6345 82 72.1135 82Z"
          fill="#EAEEF9"
        />
        <path
          d="M78.407 60.532H8.28588C6.97471 60.532 5.92578 59.4924 5.92578 58.1929V8.21317C5.92578 6.91364 6.97471 5.87402 8.28588 5.87402H78.4332C79.7444 5.87402 80.7933 6.91364 80.7933 8.21317V58.1929C80.7933 59.4924 79.7444 60.532 78.4332 60.532"
          fill="white"
        />
        <path
          d="M77.6215 33.9696H9.07381C8.62801 33.9696 8.28711 33.6317 8.28711 33.1899C8.28711 32.748 8.62801 32.4102 9.07381 32.4102H77.6215C78.0673 32.4102 78.4082 32.774 78.4082 33.1899C78.4082 33.6057 78.0411 33.9696 77.6215 33.9696Z"
          fill="#00C4B3"
        />
        <path
          d="M43.3472 58.5827C42.9015 58.5827 42.5605 58.2448 42.5605 57.803V8.60296C42.5605 8.16112 42.9277 7.82324 43.3472 7.82324C43.7668 7.82324 44.1339 8.18711 44.1339 8.60296V57.803C44.1339 58.2448 43.7668 58.5827 43.3472 58.5827Z"
          fill="#00C4B3"
        />
        <path
          d="M24.4411 19.519C19.2226 19.519 14.9482 23.3656 14.2927 28.3558C14.214 29.0576 14.7647 29.6813 15.4727 29.6813H33.4357C34.1437 29.6813 34.6944 29.0576 34.6157 28.3558C33.9601 23.3656 29.6595 19.519 24.4673 19.519"
          fill="#00C4B3"
        />
        <path
          d="M32.3071 14.0608C32.3071 18.3752 28.7669 21.858 24.4139 21.858C20.0608 21.858 16.5469 18.3752 16.5469 14.0608C16.5469 9.7464 20.087 6.26367 24.4139 6.26367C28.7407 6.26367 32.3071 9.7464 32.3071 14.0608Z"
          fill="white"
        />
        <path
          d="M29.9474 14.061C29.9474 17.0759 27.4824 19.519 24.4405 19.519C21.3986 19.519 18.9336 17.0759 18.9336 14.061C18.9336 11.0461 21.3986 8.60303 24.4405 8.60303C27.4824 8.60303 29.9474 11.0461 29.9474 14.061Z"
          fill="#00C4B3"
        />
        <path
          d="M62.2536 19.519C57.0351 19.519 52.7607 23.3656 52.1052 28.3558C52.0265 29.0576 52.5772 29.6813 53.2852 29.6813H71.2482C71.9562 29.6813 72.5069 29.0576 72.4282 28.3558C71.7726 23.3656 67.472 19.519 62.2798 19.519"
          fill="#00416B"
        />
        <path
          d="M70.1469 14.0608C70.1469 18.3752 66.6068 21.858 62.2537 21.858C57.9006 21.858 54.3867 18.3752 54.3867 14.0608C54.3867 9.7464 57.9269 6.26367 62.2537 6.26367C66.5806 6.26367 70.1469 9.7464 70.1469 14.0608Z"
          fill="white"
        />
        <path
          d="M67.7618 14.061C67.7618 17.0759 65.2968 19.519 62.2549 19.519C59.213 19.519 56.748 17.0759 56.748 14.061C56.748 11.0461 59.213 8.60303 62.2549 8.60303C65.2968 8.60303 67.7618 11.0461 67.7618 14.061Z"
          fill="#00416B"
        />
        <path
          d="M24.4411 47.2505C19.2226 47.2505 14.9482 51.0971 14.2927 56.0873C14.214 56.789 14.7647 57.4128 15.4727 57.4128H33.4357C34.1437 57.4128 34.6944 56.789 34.6157 56.0873C33.9601 51.0971 29.6595 47.2505 24.4673 47.2505"
          fill="#00416B"
        />
        <path
          d="M32.3071 41.7928C32.3071 46.1072 28.7669 49.5899 24.4139 49.5899C20.0608 49.5899 16.5469 46.1072 16.5469 41.7928C16.5469 37.4783 20.087 33.9956 24.4139 33.9956C28.7407 33.9956 32.3071 37.4783 32.3071 41.7928Z"
          fill="white"
        />
        <path
          d="M29.9474 41.7925C29.9474 44.8074 27.4824 47.2505 24.4405 47.2505C21.3986 47.2505 18.9336 44.8074 18.9336 41.7925C18.9336 38.7776 21.3986 36.3345 24.4405 36.3345C27.4824 36.3345 29.9474 38.7776 29.9474 41.7925Z"
          fill="#00416B"
        />
        <path
          d="M62.2536 47.2505C57.0351 47.2505 52.7607 51.0971 52.1052 56.0873C52.0265 56.789 52.5772 57.4128 53.2852 57.4128H71.2482C71.9562 57.4128 72.5069 56.789 72.4282 56.0873C71.7726 51.0971 67.472 47.2505 62.2798 47.2505"
          fill="#00C4B3"
        />
        <path
          d="M70.1469 41.7928C70.1469 46.1072 66.6068 49.5899 62.2537 49.5899C57.9006 49.5899 54.3867 46.1072 54.3867 41.7928C54.3867 37.4783 57.9269 33.9956 62.2537 33.9956C66.5806 33.9956 70.1469 37.4783 70.1469 41.7928Z"
          fill="white"
        />
        <path
          d="M67.7618 41.7925C67.7618 44.8074 65.2968 47.2505 62.2549 47.2505C59.213 47.2505 56.748 44.8074 56.748 41.7925C56.748 38.7776 59.213 36.3345 62.2549 36.3345C65.2968 36.3345 67.7618 38.7776 67.7618 41.7925Z"
          fill="#00C4B3"
        />
        <path
          d="M92.9874 72.8254C91.9647 72.8254 90.942 72.4356 90.1553 71.6559L58.766 40.5452C57.1926 38.9858 57.1926 36.4647 58.766 34.9313C60.3394 33.3719 62.883 33.3719 64.4302 34.9313L95.8195 66.0419C97.3929 67.6013 97.3929 70.1224 95.8195 71.6559C95.0328 72.4356 94.0101 72.8254 92.9874 72.8254Z"
          fill="#00416B"
        />
        <path
          d="M87.5599 40.0255C87.5599 52.9687 76.9657 63.4429 63.9065 63.4429C50.8473 63.4429 40.2793 52.9427 40.2793 40.0255C40.2793 27.1082 50.8735 16.582 63.9065 16.582C76.9395 16.582 87.5599 27.0822 87.5599 40.0255Z"
          fill="#00C4B3"
        />
        <path
          d="M82.814 40.0253C82.814 50.3695 74.3439 58.7644 63.907 58.7644C53.4701 58.7644 45 50.3695 45 40.0253C45 29.6811 53.4701 21.2861 63.907 21.2861C74.3439 21.2861 82.814 29.6811 82.814 40.0253Z"
          fill="#EAEEF9"
        />
        <path
          d="M80.4532 40.0255C80.4532 49.0702 73.0582 56.4255 63.9063 56.4255C54.7544 56.4255 47.3594 49.0702 47.3594 40.0255C47.3594 30.9808 54.7544 23.6255 63.9063 23.6255C73.0582 23.6255 80.4532 30.9548 80.4532 40.0255Z"
          fill="#FBFCFE"
        />
        <path
          d="M64.194 39.4014C58.9755 39.4014 54.7012 43.248 54.0456 48.2381C53.9407 48.9399 54.5176 49.5636 55.2256 49.5636H73.1886C73.8966 49.5636 74.4473 48.9399 74.3686 48.2381C73.713 43.248 69.4124 39.4014 64.2202 39.4014"
          fill="#00C4B3"
        />
        <path
          d="M72.0883 33.9436C72.0883 38.2581 68.5482 41.7408 64.2213 41.7408C59.8945 41.7408 56.3281 38.2581 56.3281 33.9436C56.3281 29.6292 59.8683 26.1465 64.2213 26.1465C68.5744 26.1465 72.0883 29.6292 72.0883 33.9436Z"
          fill="white"
        />
        <path
          d="M69.7286 33.9434C69.7286 36.9583 67.2636 39.4014 64.2217 39.4014C61.1798 39.4014 58.7148 36.9583 58.7148 33.9434C58.7148 30.9285 61.1798 28.4854 64.2217 28.4854C67.2636 28.4854 69.7286 30.9285 69.7286 33.9434Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1476">
          <rect width="97" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
